import { getCurrentInstance } from "vue";

export const useToast = () => {
  const app = getCurrentInstance();

  if (app) {
    return app.proxy.$root.$bvToast;
  }
};
